// eslint-disable-next-line import/prefer-default-export
export const GET_WISH_LIST = 'GET_WISH_LIST';
export const RESET_WISH_LIST = 'RESET_WISH_LIST';
